/* ========================================================================== 
  VIDEO EMBED PLAY
  ========================================================================== */
const player = document.querySelector(".js-youtube-player");

let tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";

let firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let YT, fullScreenPlayer, videoID;

function onYouTubeIframeAPIReady() {
    if (typeof player != "undefined" && player != null) {
        fullScreenPlayer = createPlayer(player);
    }
}

function createPlayer(videoWrapper) {
    return new YT.Player(videoWrapper, {
        height: videoWrapper.height,
        width: videoWrapper.width,
        videoId: videoWrapper.dataset.src,
        playerVars: {
            autoplay: 0,
            controls: 1,
            autohide: 1,
            origin: "window.location"
        }
    });
}
 

function feedVideoCards() {
   
    playVideoBtns.forEach((playVideoBtn) => { 
        playVideoBtn.addEventListener("click", () => {
            body.classList.add("stopScrolling");
            videoID = playVideoBtn.dataset.id;
            fullScreenPlayer.loadVideoById(videoID, 0, "default");
            gsap.to(videoOverlay, 0.3, { autoAlpha: 1 });
            menuButton.classList.add('menu-button--active');
            closeOverlay.classList.add('is-active');
        });
    });

    if (typeof closeOverlay != "undefined" && closeOverlay != null) { 
        closeOverlay.addEventListener("click", () => {
            body.classList.add("stopScrolling");
            gsap.to(videoOverlay, 0.3, { autoAlpha: 0 });
            fullScreenPlayer.pauseVideo();
            menuButton.classList.remove('menu-button--active');
            closeOverlay.classList.remove('is-active');
        });
    }
    
}
    

